<div class="phone-input">
  <select
    class="phone-prefix"
    [ngModel]="prefix"
    [disabled]="disabled"
    (ngModelChange)="onPrefixChange($event)"
  >
    <option *ngFor="let p of prefixes" [value]="p.code">{{ p.code }} {{ p.country }}</option>
  </select>
  <input
    #numberInput
    type="tel"
    inputmode="tel"
    class="phone-number"
    [ngModel]="number"
    [disabled]="disabled"
    [placeholder]="placeholder"
    (ngModelChange)="onNumberChange($event, numberInput)"
  />
</div>
